import type { ArdoqId } from '@ardoq/api-types';
import { componentInterface } from '../componentInterface';
import { isComponentIdIncludedInContextByFilter } from './isComponentIdIncludedInContextByFilter';

export const componentOrDescendantsAreIncludedInContextByFilter = (
  componentId: ArdoqId
): boolean =>
  isComponentIdIncludedInContextByFilter(componentId) ||
  componentInterface
    .getChildren(componentId)
    .some(({ _id }) => componentOrDescendantsAreIncludedInContextByFilter(_id));
